import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { CommonModule } from "@angular/common";
import { LoginNewComponent } from "./login-new/login-new.component";
import { OnboardingBannerComponent } from "./onboarding-banner/onboarding-banner.component";
import { RegisterComponent } from "./register/register.component";
import { TranslateModule } from "@ngx-translate/core";
import { OtpVerificationComponent } from "./otp-verification/otp-verification.component";
import { OrganisationDetailsComponent } from "./organisation-details/organisation-details.component";
import { CreatePasswordComponent } from "./create-password/create-password.component";
import { InviteEmployeesComponent } from "./invite-employees/invite-employees.component";
import { AppDownloadComponent } from "./app-download/app-download.component";

@Component({
    selector: "app-onboarding",
    templateUrl: "./onboarding.component.html",
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        LoginNewComponent,
        OnboardingBannerComponent,
        RegisterComponent,
        OtpVerificationComponent,
        OrganisationDetailsComponent,
        CreatePasswordComponent,
        InviteEmployeesComponent,
        AppDownloadComponent
    ]
})
export class OnboardingComponent implements OnInit {
  constructor(private router: Router) {}
  isLoginActive: boolean = true;
  isSignupActive: boolean = false;
  isOTPVerificationActive = false;
  isCreatePasswordActive = false;
  isOrgDetailActive = false;
  isInviteEmployeeActive = false;
  isAppDownloadActive = false;

  currentStep = 1;
  
  isChrome: boolean =
  navigator.userAgent.toLowerCase().indexOf("chrome") > -1 &&
  navigator.vendor.toLowerCase().indexOf("google") > -1 &&
  !(navigator.userAgent.toLowerCase().indexOf("edg/") > -1);
  ngOnInit(): void {

    if(this.router.url.includes("register")){
      this.navigateToRoute(2);
    }
  }

  navigateToRoute(step: number) {
    this.currentStep = step;
    switch (step) {
      case 1:
        this.isLoginActive = true;
        this.isSignupActive = false;
        this.isOTPVerificationActive = false;
        this.isCreatePasswordActive = false;
        this.isOrgDetailActive = false;
        this.isInviteEmployeeActive = false;
        this.isAppDownloadActive = false;
        break;
      case 2:
        this.isLoginActive = false;
        this.isSignupActive = true;
        this.isOTPVerificationActive = false;
        this.isCreatePasswordActive = false;
        this.isOrgDetailActive = false;
        this.isInviteEmployeeActive = false;
        this.isAppDownloadActive = false;
        break;
      case 3:
        this.isLoginActive = false;
        this.isSignupActive = false;
        this.isOTPVerificationActive = true;
        this.isCreatePasswordActive = false;
        this.isOrgDetailActive = false;
        this.isInviteEmployeeActive = false;
        this.isAppDownloadActive = false;
        break;
      case 4:
        this.isLoginActive = false;
        this.isSignupActive = false;
        this.isOTPVerificationActive = false;
        this.isCreatePasswordActive = true;
        this.isOrgDetailActive = false;
        this.isInviteEmployeeActive = false;
        this.isAppDownloadActive = false;
        break;
      case 5:
        this.isLoginActive = false;
        this.isSignupActive = false;
        this.isOTPVerificationActive = false;
        this.isCreatePasswordActive = false;
        this.isOrgDetailActive = true;
        this.isInviteEmployeeActive = false;
        this.isAppDownloadActive = false;
        break;
      case 6:
        this.isLoginActive = false;
        this.isSignupActive = false;
        this.isOTPVerificationActive = false;
        this.isCreatePasswordActive = false;
        this.isOrgDetailActive = false;
        this.isInviteEmployeeActive = true;
        this.isAppDownloadActive = false;
        break;
      case 7:
        this.isLoginActive = false;
        this.isSignupActive = false;
        this.isOTPVerificationActive = false;
        this.isCreatePasswordActive = false;
        this.isOrgDetailActive = false;
        this.isInviteEmployeeActive = false;
        this.isAppDownloadActive = true;
        break;
    }
  }


  gotoLogin() {
    this.navigateToRoute(1);
  }

  gotoSignUp() {
    this.navigateToRoute(2);
  }

  onLoginClick($event: any) {
    this.navigateToRoute($event);
  }

  gotoNextStep(step: number) {
    this.navigateToRoute(step);
  }
}
